import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import SEOHead from '../components/SEOHead';
import { MEDIA_ASSETS } from '../utils/mediaAssets';

const HomePage = () => {
  return (
    <MainLayout>
      <SEOHead 
        title="Refresh Bulgaria - За по-чиста и зелена България"
        description="Присъединете се към нашите доброволчески акции за почистване на природата в България. Заедно можем да направим България по-чиста и зелена!"
        keywords="екология България, доброволчески акции, почистване природа, околна среда, зелена България, екологични инициативи, volunteer cleanup Bulgaria"
        url="https://refreshbulgaria.com"
      />
      {/* Hero section - Full width */}
      <section className="mb-8">
        <div className="relative w-full h-80 md:h-96 lg:h-[500px] overflow-hidden">
          <img 
            src={MEDIA_ASSETS.heroImage} 
            alt="Панорамна снимка на еко акция Refresh Bulgaria за почистване на природата в България" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
            <div className="text-center text-white p-6">
                              <h1 className="text-4xl md:text-4xl lg:text-5xl font-bold mb-2 md:mb-4">
                  Refresh<span className="text-green-300">Bulgaria</span>
                </h1>
                <p className="text-base md:text-xl font-semibold opacity-90 max-w-2xl">
                    Промяната започва от теб
                  </p>
            </div>
          </div>
        </div>
      </section>

      <div className="max-w-screen-xl mx-auto px-4">
        <main>

          {/* Mission Statement */}
          <section className="mb-8">
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-md">
              <h2 className="text-2xl md:text-3xl font-bold text-green-800 mb-4 text-center">Нашата мисия</h2>
              <p className="text-lg text-gray-700 leading-relaxed text-center max-w-4xl mx-auto">
                Refresh Bulgaria е гражданска инициатива, посветена на опазването на околната среда в България чрез доброволчески акции, образователни кампании и активна ангажираност в локални общности. Нашата цел е проста – <span className="font-semibold text-green-700">по-чист и екологичен начин на живот</span>.
              </p>
            </div>
          </section>

                    {/* Call to Action */}
                    <section className="mb-8">
            <div className="bg-gradient-to-r from-green-700 to-green-600 rounded-lg p-8 text-white text-center">
              <h2 className="text-2xl md:text-3xl font-bold mb-4">Заедно за по-чиста България!</h2>
              <p className="text-lg mb-6 opacity-90">Присъединете се към движението, което вече прави разликата</p>
              <Link 
                to="/about" 
                className="inline-flex items-center bg-white text-green-700 hover:bg-green-50 font-semibold py-3 px-6 rounded-lg transition-colors"
              >
                Научете повече за нас
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
            </div>
          </section>

          {/* What We Do Section */}
          <section className="mb-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h2 className="text-2xl font-bold text-green-800 mb-6 text-center">Какво правим</h2>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-green-800 mb-2">Почистване на природата</h3>
                  <p className="text-gray-600">Организираме редовни акции за почистване на паркове, гори и обществени места.</p>
                </div>
                <div className="text-center">
                  <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-green-800 mb-2">Общностни акции</h3>
                  <p className="text-gray-600">Обединяваме хора от различни възрасти в обща кауза за околната среда.</p>
                </div>
                <div className="text-center">
                  <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C20.832 18.477 19.246 18 17.5 18c-1.746 0-3.332.477-4.5 1.253" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-green-800 mb-2">Екологично образование</h3>
                  <p className="text-gray-600">Повишаваме съзнанието за екологичните проблеми в България.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Action Cards Section */}
          <section className="mb-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Events Card */}
              <div className="relative rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 h-64 md:h-72">
                <img 
                  src={MEDIA_ASSETS.cardImage1} 
                  alt="Доброволци на Refresh Bulgaria в акция за почистване на околната среда" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end p-6">
                  <h3 className="text-xl font-bold text-white mb-3">Предстоящи събития</h3>
                  <p className="text-white text-opacity-90 mb-4">Разгледайте нашите предстоящи акции за почистване и се включете в борбата за по-чиста България.</p>
                  <Link 
                    to="/events" 
                    className="inline-flex items-center bg-white text-green-700 hover:bg-green-50 font-semibold py-3 px-6 rounded-lg transition-colors w-fit"
                  >
                    Вижте събитията
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>

              {/* Get Involved Card */}
              <div className="relative rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 h-64 md:h-72">
                <img 
                  src={MEDIA_ASSETS.cardImage2} 
                  alt="Еко акция на Refresh Bulgaria за опазване на природата и околната среда" 
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-end p-6">
                  <h3 className="text-xl font-bold text-white mb-3">Включете се</h3>
                  <p className="text-white text-opacity-90 mb-4">Станете част от нашата общност на доброволци и помогнете за по-чиста околна среда в България.</p>
                  <Link 
                    to="/get-involved" 
                    className="inline-flex items-center bg-white text-green-700 hover:bg-green-50 font-semibold py-3 px-6 rounded-lg transition-colors w-fit"
                  >
                    Присъединете се
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          </section>


        </main>
      </div>
    </MainLayout>
  );
};

export default HomePage; 